import React, { createContext, useContext, useState, useEffect } from 'react';

const MerchantAuthContext = createContext(null);

export const useMerchantAuth = () => {
  const context = useContext(MerchantAuthContext);
  if (!context) {
    throw new Error('useMerchantAuth must be used within MerchantAuthProvider');
  }
  return context;
};

export const MerchantAuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('merchant_token');
    const storedMerchant = localStorage.getItem('merchant_data');
    
    if (storedToken && storedMerchant) {
      setToken(storedToken);
      setMerchant(JSON.parse(storedMerchant));
    }
    setLoading(false);
  }, []);

  const register = async (name, email, password, callbackUrl, returnUrl) => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      
      const response = await fetch(`${backendUrl}/api/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name,
          email,
          password,
          callback_url: callbackUrl,
          return_url: returnUrl
        })
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('merchant_token', data.access_token);
        localStorage.setItem('merchant_data', JSON.stringify(data.merchant));
        
        setToken(data.access_token);
        setMerchant(data.merchant);
        return { success: true, data };
      } else {
        return { success: false, error: data.detail || 'Error al registrar' };
      }
    } catch (error) {
      return { success: false, error: 'Error de conexión' };
    }
  };

  const login = async (email, password) => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      
      const response = await fetch(`${backendUrl}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('merchant_token', data.access_token);
        localStorage.setItem('merchant_data', JSON.stringify(data.merchant));
        
        setToken(data.access_token);
        setMerchant(data.merchant);
        return { success: true };
      } else {
        return { success: false, error: data.detail || 'Credenciales inválidas' };
      }
    } catch (error) {
      return { success: false, error: 'Error de conexión' };
    }
  };

  const logout = () => {
    localStorage.removeItem('merchant_token');
    localStorage.removeItem('merchant_data');
    setToken(null);
    setMerchant(null);
  };

  const fetchWithAuth = async (url, options = {}) => {
    const headers = {
      ...options.headers,
      'Authorization': `Bearer ${token}`
    };

    return fetch(url, { ...options, headers });
  };

  const value = {
    token,
    merchant,
    loading,
    isAuthenticated: !!token,
    register,
    login,
    logout,
    fetchWithAuth
  };

  return <MerchantAuthContext.Provider value={value}>{children}</MerchantAuthContext.Provider>;
};
